import { $t } from '@/i18n';
import { CATEGORY } from './const';
import { useFileDialog } from '@vueuse/core';
// 提取文件数据
export const getFileDataAtom = {
    id: 'xy:getFileData',
    name: $t('k_a58e76c4'),
    desc: $t('k_4c6e5af6'),
    category: CATEGORY.EXPORT,
    paramsSchema: {
        type: 'object',
        fields: [
            {
                id: 'multiple',
                type: 'boolean',
                title: $t('k_bcf42508'),
                default: false,
                condition: '!params.enableDirectory',
            },
            {
                id: 'enableDirectory',
                type: 'boolean',
                title: $t('k_6e046da0'),
                default: false,
                condition: '!params.multiple',
            },
            {
                id: 'codepage',
                type: 'string',
                title: $t('k_a07ade'),
                enum: [
                    {
                        label: $t('k_1a462199'),
                        value: '',
                    },
                    {
                        label: 'UTF-8',
                        value: 'UTF-8',
                    },
                    {
                        label: 'GBK / GB2312',
                        value: 'GBK',
                    },
                ],
                default: '',
            },
        ],
    },
    execute: async (_ctx, params) => {
        const { multiple = false, enableDirectory = false, codepage = '' } = params;
        const acceptSuffix = ['.sql', '.pck'];
        const acceptType = ['text/plain', 'application/json', 'text/csv'];
        const acceptTypeStr = [...acceptType, ...acceptSuffix].join(',');
        const result = await new Promise((rs, rj) => {
            const { open, onCancel, onChange } = useFileDialog({
                accept: acceptTypeStr,
                multiple,
                directory: enableDirectory,
            });
            onChange((rawFiles) => {
                if (!rawFiles?.length)
                    rs(null);
                const files = Array.from(rawFiles)
                    .filter(file => acceptType.includes(file.type) || acceptSuffix.some(suffix => file.name.endsWith(suffix)));
                if (!files.length)
                    rj(new Error($t('k_6808e00c')));
                const fileData = {};
                const fileObjects = {};
                const readerPromises = files.map(file => new Promise((resolveReader) => {
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        const data = e?.target?.result;
                        if (!data || typeof data !== 'string') {
                            fileData[file.name] = '';
                        }
                        else {
                            fileData[file.name] = data;
                        }
                        fileObjects[file.name] = file;
                        resolveReader();
                    };
                    if (codepage) {
                        reader.readAsText(file, codepage);
                    }
                    else {
                        reader.readAsText(file);
                    }
                }));
                Promise.all(readerPromises).then(() => {
                    if (multiple || enableDirectory) {
                        rs({ data: fileData, __file__: fileObjects });
                    }
                    else {
                        rs({ data: Object.values(fileData)[0], __file__: Object.values(fileObjects)[0] });
                    }
                }, (err) => {
                    rj(new Error($t('k_a4ab74ec', { arg_0: err })));
                });
            });
            onCancel(() => rs(null));
            open();
        });
        return result;
    },
    returnValue: {
        type: 'object',
        fields: [
            {
                id: 'data',
                type: 'object',
                description: $t('k_86a61cad'),
            },
            {
                id: '__file__',
                type: 'object',
                description: $t('k_2683fbfa'),
            },
        ],
    },
};
